// CAROUSEL INFORMATION
export const CarouselData = [
  {
    title: "Easy",
    subText:
      "Enjoy seamless access to our multiple products by signing up just once",
  },
  {
    title: "Fast",
    subText: "Buy airtime and pay for subscription all on one platform.",
  },
  {
    title: "Secure",
    subText: "Easy, fast and secure way to make and receive payments anywhere.",
  },
];

// CARD DATA FOR ALL AUTH FORMS
export const CardData = {
  CREATE_PASSWORD: {
    title: "Create a New Password",
  },
  UPDATE_REQUIRED: {
    title: "Update Required",
    linkText: "Create an account",
    linkAddress: "/auth/signup",
    linkPrefix: "First time here?",
  },
  LOGIN: {
    title: "Login to your account",
    linkText: "Create an account",
    linkAddress: "/auth/signup",
    linkPrefix: "First time here?",
  },
  SIGNUP_STEP_ONE: {
    title: "Setup your account",
    linkText: "Sign In",
    linkAddress: "/auth/login",
    linkPrefix: "Have an account?",
  },
  SIGNUP_STEP_TWO: {
    title: "ID Verification",
  },
  SIGNUP_STEP_THREE: {
    title: "Secure your account",
  },
  SIGNUP_UPDATE_ACCOUNT: {
    title: "Update your account",
  },
  FORGOT_PASSWORD: {
    title: "Forgot Password",
    linkText: "Create an account",
    linkAddress: "/auth/signup",
    linkPrefix: "First time here?",
  },
};

//PAGES ROUTES
export const AUTH_PAGE_ROUTES = {
  LOGIN: "/auth/login",
  FORGOT_PASSWORD: "/auth/forgot-password",
  CREATE_PASSWORD: "/auth/create-password",
  SIGNUP: "/auth/signup",
  ACCOUNT_UPDATE:"/auth/account-update",
};

export const HOME_PAGE_ROUTES = {
  HOME: "/home/dashboard",
  AIRTIME: "/home/airtime",
  DATA: "/home/data",
  BILL_PAYMENTS: "/home/bill-payments",
  CABLE_TV: "/home/cable-tv",
  EDUCATION: "/home/education",
  BETTING: "/home/betting",
  ELECTRICITY: "/home/electricity",
  RECURRING_PAYMENTS: "/home/recurring-payments",
  WALLET: "/home/wallet",
  TRANSACTIONS: "/home/transaction",
  SETTINGS: "/home/settings",
};

export const MODAL_HEADERS = {
  FUND_WALLET: "Fund Wallet",
  FUND_BY_CARD: "Fund By Card",
  SHARE_TAG_NAME: "Share your Tagname",
  FUND_BY_TRANSFER: "Fund By Transfer",
  TRANSACTION_PIN: "Enter transaction PIN",
  CREATE_TRANSACTION_PIN: "Create transaction PIN",
  RESET_TRANSACTION_PIN: "Reset transaction PIN",
  TRANSFER_FUNDS: "Transfer Funds",
};

export const FUND_WALLET_OPTIONS = [
  {
    id: "tagname",
    option: "Share your @Tagname",
    desc: "Receive money from other PayXpress users with your unique Tagname.",
  },
  {
    id: "bank_transfer",
    option: "Bank Transfer",
    desc: "From bank app or internet banking.",
  },
];

export const TransferMethods = [
  {
    label: "Tagname",
    value: "tag",
  },
  {
    label: "Wallet Details",
    value: "wallet",
  },
];

export const NetworkItems = [
  {
    label: "Mtn Nigeria",
    value: "mtn",
  },
  {
    label: "Glo Nigeria",
    value: "glo",
  },
];

export const DataPlanItems = [
  {
    label: "Data Plan A",
    value: "plan A",
  },
  {
    label: "Data Plan B",
    value: "plan B",
  },
];